import { eventQBus } from '@otto-ec/global-resources/event-q-bus';
import { BaseComponent2 } from '../../_common/client/base-component2';
import { EFFECTIVE_PRICE_CHANGED_TOPIC, EffectivePriceChangeEvent } from '../../price/client/effective-price';

export class DelayedPaymentComponent extends BaseComponent2 {
    public rootSelector = '.js_pdp_delayed_payment';
    private readonly priceElementSelector = '.pdp_delayed_payment__price';

    public override async init(): Promise<void> {
        eventQBus.on(EFFECTIVE_PRICE_CHANGED_TOPIC, this.variationChangeListener.bind(this));
    }

    private variationChangeListener(event: EffectivePriceChangeEvent): void {
        const newPrice = (event.newPriceCents * 0.035) / 100.0;

        if (this.priceElement) {
            this.priceElement.innerHTML = newPrice.toFixed(2).toString().replace('.', ',');
        }
    }

    private get priceElement(): HTMLElement | null | undefined {
        return this.rootElement?.querySelector(this.priceElementSelector);
    }
}
